import { EntityModel } from '@/interfaces'
import {
  ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY,
  CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
  DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
  FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
  SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY,
  UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
} from './graphql'

const cmsNewsletterRegisterBlockModel: EntityModel = {
  name: 'newsletterRegisterBlock',
  namePlural: 'newsletterRegisterBlocks',
  uniqueName: 'cmsNewsletterRegisterBlock',
  uniqueNamePlural: 'cmsNewsletterRegisterBlocks',
  path: 'cms/blocks/newsletter_register_block',
  baseUrl: '/cms/blocks/newsletter_register_blocks',
  translationPrefix: 'entities:cmsNewsletterRegisterBlock.',
  getDisplayName: (values: any) => {
    return 'CMS Newsletter Register Block'
  },
  gql: {
    getAll: ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY,
    getSingle: SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY,
    create: CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
    update: UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
    delete: DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
  },
  attributes: {
    fluid: {
      name: 'fluid',
      label: 'entities:cmsNewsletterRegisterBlock.attributes.fluid.label',
      type: 'value',
      dataType: 'boolean',
      defaultValue: true,
      defaultInput: false,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsNewsletterRegisterBlockModel
